import React from "react";
import { MapPin, Phone } from "lucide-react";
import { siteData } from "../data/mockData";

const TopBar = () => {
  return (
    <div className="w-full bg-[#1CA0B9] py-2.5 px-6 md:px-16">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between">
        <a
          href={siteData.clinic.mapLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-white text-sm hover:opacity-80 transition-opacity"
        >
          <MapPin className="w-4 h-4" />
          <span className="font-poppins">{siteData.clinic.address}</span>
        </a>
        <div className="flex items-center gap-4 md:gap-6">
          <a
            href={`tel:${siteData.clinic.phone}`}
            className="flex items-center gap-2 text-white text-sm hover:opacity-80 transition-opacity"
          >
            <Phone className="w-4 h-4" />
            <span className="font-poppins">{siteData.clinic.phone}</span>
          </a>
          <span className="text-white/40 hidden md:inline">|</span>
          <a
            href="tel:+919751203819"
            className="hidden md:flex items-center gap-2 text-white text-sm hover:opacity-80 transition-opacity"
          >
            <Phone className="w-4 h-4" />
            <span className="font-poppins">+91 97512 03819</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
